// staff overiview Employee Performance
export const STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_REQUEST = 'STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_REQUEST';
export const STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_SUCCESS = 'STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_SUCCESS';
export const STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_FAILURE = 'STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_FAILURE';

// staff overiview Activities
export const STAFF_OVERVIEW_ACTIVITIES_REQUEST = 'STAFF_OVERVIEW_ACTIVITIES_REQUEST';
export const STAFF_OVERVIEW_ACTIVITIES_SUCCESS = 'STAFF_OVERVIEW_ACTIVITIES_SUCCESS';
export const STAFF_OVERVIEW_ACTIVITIES_FAILURE = 'STAFF_OVERVIEW_ACTIVITIES_FAILURE';

//staff overiview Employee Performance Table
export const STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_TABLE_REQUEST = 'STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_TABLE_REQUEST';
export const STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_TABLE_SUCCESS = 'STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_TABLE_SUCCESS';
export const STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_TABLE_FAILURE = 'STAFF_OVERVIEW_EMPLOYEE_PERFORMANCE_TABLE_FAILURE';

//staff trend sales performance
export const STAFF_TREND_SALES_PERFORMANCE_REQUEST = 'STAFF_TREND_SALES_PERFORMANCE_REQUEST';
export const STAFF_TREND_SALES_PERFORMANCE_SUCCESS = 'STAFF_TREND_SALES_PERFORMANCE_SUCCESS';
export const STAFF_TREND_SALES_PERFORMANCE_FAILURE = 'STAFF_TREND_SALES_PERFORMANCE_FAILURE';

// staff trend sales performance orders
// export const STAFF_TREND_SALES_PERFORMANCE_ORDERS_REQUEST = 'STAFF_TREND_SALES_PERFORMANCE_ORDERS_REQUEST';
// export const STAFF_TREND_SALES_PERFORMANCE_ORDERS_SUCCESS = 'STAFF_TREND_SALES_PERFORMANCE_ORDERS_SUCCESS';
// export const STAFF_TREND_SALES_PERFORMANCE_ORDERS_FAILURE = 'STAFF_TREND_SALES_PERFORMANCE_ORDERS_FAILURE';

// staff trend revenue impact performance
export const STAFF_TREND_REVENUE_IMPACT_PERFORMANCE_REQUEST = 'STAFF_TREND_REVENUE_IMPACT_PERFORMANCE_REQUEST';
export const STAFF_TREND_REVENUE_IMPACT_PERFORMANCE_SUCCESS = 'STAFF_TREND_REVENUE_IMPACT_PERFORMANCE_SUCCESS';
export const STAFF_TREND_REVENUE_IMPACT_PERFORMANCE_FAILURE = 'STAFF_TREND_REVENUE_IMPACT_PERFORMANCE_FAILURE';

// staff trend  Error Performance
export const STAFF_TREND_ERROR_PERFORMANCE_REQUEST = 'STAFF_TREND_ERROR_PERFORMANCE_REQUEST';
export const STAFF_TREND_ERROR_PERFORMANCE_SUCCESS = 'STAFF_TREND_ERROR_PERFORMANCE_SUCCESS';
export const STAFF_TREND_ERROR_PERFORMANCE_FAILURE = 'STAFF_TREND_ERROR_PERFORMANCE_FAILURE';




